var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.token)?_c('div',{staticClass:"floating-ball",style:({ left: _vm.posX + 'px', top: _vm.posY + 'px' }),on:{"mousedown":_vm.onMouseDown,"click":_vm.onClick}},[_c('div',{staticClass:"ball-inner"},[_vm._t("default",function(){return [_vm._m(0)]})],2)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ball-text"},[_vm._v("商家"),_c('br'),_vm._v("指南")])
}]

export { render, staticRenderFns }